import { showAlert } from '../core/alerts.js';

export function initDeleteButtons() {
    $(document).on('click', '.btn-delete', function (e) {
        e.preventDefault();
        var $self = $(this);
        var $form = $self.closest('form');
        var item = $self.attr('data-type') ? $self.attr('data-type') : 'item';
        var tmp = $(
            '<input type="hidden" name="' +
                this.name +
                '" value="' +
                $self.val() +
                '" />'
        ).appendTo($form);

        showAlert({
            title: 'Are you sure you want to delete this ' + item + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#b20000',
            confirmButtonText: 'Delete',
        }).then((result) => {
            if (result.isConfirmed) {
                $form.submit();
            }

            tmp.remove();
        });
    });
}
